import { useEffect, useState } from "react";

/**
 * Words that change in place, the libraries.dev thinking-orbs way: the old words slide up,
 * blur and fade out while the new ones rise in (150 ms). `shimmer` adds the light band that
 * sweeps across words meaning "working". Reduced motion: an instant swap, no band.
 */
export default function SwapText({ text, shimmer = false, className = "" }: {
  text: string; shimmer?: boolean; className?: string;
}) {
  const [view, setView] = useState({ text, prev: "", n: 0 });
  if (view.text !== text) setView({ text, prev: view.text, n: view.n + 1 });
  useEffect(() => {
    if (!view.prev) return;
    const n = view.n;
    const timer = window.setTimeout(() => setView((v) => (v.n === n ? { ...v, prev: "" } : v)), 200);
    return () => window.clearTimeout(timer);
  }, [view.n, view.prev]);
  return (
    <span className={`swapText ${className}`}>
      {view.prev && <span className="swapText__word is-out" aria-hidden="true">{view.prev}</span>}
      <span key={view.n} className={`swapText__word${view.n ? " is-in" : ""}${shimmer ? " is-shimmer" : ""}`}
        data-text={view.text}>{view.text}</span>
    </span>
  );
}
